import { IOption } from '@cian/ui-kit/types';

import { DISTRICTS_STATS } from '../../../../constants/districtsStats';

export function getOptions(): IOption[] {
  return Object.keys(DISTRICTS_STATS)
    .sort((a, b) => a.localeCompare(b))
    .map(district => ({ label: district, value: district }));
}
